import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';

const TableDraggableBody = SortableContainer(({ children }) => {
    return <tbody>{children}</tbody>;
});

export default TableDraggableBody;
